import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherNotifications = () => {
  const routes = all_routes;
  const [filterType, setFilterType] = useState("all");

  const notifications = [
    {
      id: 1,
      type: "submission",
      title: "New Homework Submission",
      message: "Emma Johnson submitted Math Assignment #5",
      time: "5 minutes ago",
      read: false,
      icon: "ti-file-upload",
      color: "success",
    },
    {
      id: 2,
      type: "grade",
      title: "Grade Entry Reminder",
      message: "Don't forget to enter grades for Physics Quiz - due today",
      time: "1 hour ago",
      read: false,
      icon: "ti-clipboard-list",
      color: "warning",
    },
    {
      id: 3,
      type: "message",
      title: "New Parent Message",
      message: "John Smith sent you a message about his daughter's progress",
      time: "2 hours ago",
      read: true,
      icon: "ti-message",
      color: "primary",
    },
    {
      id: 4,
      type: "admin",
      title: "School Announcement",
      message: "Faculty meeting rescheduled to tomorrow at 3 PM",
      time: "3 hours ago",
      read: true,
      icon: "ti-bell",
      color: "info",
    },
    {
      id: 5,
      type: "attendance",
      title: "Attendance Alert",
      message: "High absence rate in Grade 10A today (20% absent)",
      time: "1 day ago",
      read: true,
      icon: "ti-calendar-x",
      color: "danger",
    },
    {
      id: 6,
      type: "deadline",
      title: "Assignment Deadline",
      message: "Math homework due tomorrow - 5 students haven't submitted",
      time: "1 day ago",
      read: false,
      icon: "ti-clock-hour-4",
      color: "warning",
    },
  ];

  const notificationTypes = [
    { value: "all", label: "All Notifications" },
    { value: "submission", label: "Submissions" },
    { value: "grade", label: "Grades" },
    { value: "message", label: "Messages" },
    { value: "admin", label: "Admin" },
    { value: "attendance", label: "Attendance" },
    { value: "deadline", label: "Deadlines" },
  ];

  const filteredNotifications = notifications.filter(
    (notification) => filterType === "all" || notification.type === filterType
  );

  const unreadCount = notifications.filter((n) => !n.read).length;

  const markAsRead = (id: number) => {
    // TODO: API call to mark notification as read
    console.log(`Marking notification ${id} as read`);
  };

  const markAllAsRead = () => {
    // TODO: API call to mark all notifications as read
    console.log("Marking all notifications as read");
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">
                Notifications
                {unreadCount > 0 && (
                  <span className="badge bg-danger ms-2">{unreadCount}</span>
                )}
              </h3>
              <p className="text-muted mb-0">
                Stay updated with important school activities
              </p>
            </div>
            <div className="col-auto">
              {unreadCount > 0 && (
                <button
                  className="btn btn-outline-primary"
                  onClick={markAllAsRead}
                >
                  <i className="ti ti-check-all me-1"></i>
                  Mark All Read
                </button>
              )}
            </div>
          </div>

          {/* Notification Stats */}
          <div className="row mb-4">
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-danger-transparent mx-auto mb-2">
                    <i className="ti ti-bell text-danger"></i>
                  </div>
                  <h5 className="text-danger">{unreadCount}</h5>
                  <small>Unread</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-success-transparent mx-auto mb-2">
                    <i className="ti ti-file-upload text-success"></i>
                  </div>
                  <h5 className="text-success">
                    {
                      notifications.filter((n) => n.type === "submission")
                        .length
                    }
                  </h5>
                  <small>Submissions</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-primary-transparent mx-auto mb-2">
                    <i className="ti ti-message text-primary"></i>
                  </div>
                  <h5 className="text-primary">
                    {notifications.filter((n) => n.type === "message").length}
                  </h5>
                  <small>Messages</small>
                </div>
              </div>
            </div>
            <div className="col-md-3 col-sm-6">
              <div className="card text-center">
                <div className="card-body">
                  <div className="avatar avatar-md bg-warning-transparent mx-auto mb-2">
                    <i className="ti ti-clock text-warning"></i>
                  </div>
                  <h5 className="text-warning">
                    {notifications.filter((n) => n.type === "deadline").length}
                  </h5>
                  <small>Deadlines</small>
                </div>
              </div>
            </div>
          </div>

          {/* Filter */}
          <div className="card mb-4">
            <div className="card-body">
              <div className="row align-items-center">
                <div className="col-md-6">
                  <label className="form-label">Filter by Type</label>
                  <select
                    className="form-select"
                    value={filterType}
                    onChange={(e) => setFilterType(e.target.value)}
                  >
                    {notificationTypes.map((type) => (
                      <option key={type.value} value={type.value}>
                        {type.label}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-md-6 text-md-end mt-3 mt-md-0">
                  <Link
                    to="/teacher/settings"
                    className="btn btn-outline-secondary"
                  >
                    <i className="ti ti-settings me-1"></i>
                    Notification Settings
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Notifications List */}
          <div className="card">
            <div className="card-header">
              <h5 className="card-title mb-0">Recent Notifications</h5>
            </div>
            <div className="card-body p-0">
              {filteredNotifications.length > 0 ? (
                <div>
                  {filteredNotifications.map((notification) => (
                    <div
                      key={notification.id}
                      className={`d-flex align-items-start p-3 border-bottom ${
                        !notification.read ? "bg-light" : ""
                      }`}
                    >
                      <div
                        className={`avatar avatar-sm bg-${notification.color}-transparent me-3`}
                      >
                        <i
                          className={`${notification.icon} text-${notification.color}`}
                        ></i>
                      </div>
                      <div className="flex-fill">
                        <div className="d-flex align-items-center justify-content-between mb-1">
                          <h6
                            className={`mb-0 ${
                              !notification.read ? "fw-bold" : ""
                            }`}
                          >
                            {notification.title}
                          </h6>
                          <small className="text-muted">
                            {notification.time}
                          </small>
                        </div>
                        <p className="text-muted mb-2">
                          {notification.message}
                        </p>
                        <div className="d-flex gap-2">
                          {!notification.read && (
                            <button
                              className="btn btn-sm btn-outline-primary"
                              onClick={() => markAsRead(notification.id)}
                            >
                              Mark as Read
                            </button>
                          )}
                          <button className="btn btn-sm btn-outline-secondary">
                            View Details
                          </button>
                        </div>
                      </div>
                      {!notification.read && (
                        <div className="badge bg-primary rounded-pill ms-2">
                          New
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className="text-center py-5">
                  <div className="avatar avatar-xl bg-light-transparent mx-auto mb-3">
                    <i className="ti ti-bell-off fs-2"></i>
                  </div>
                  <h5>No notifications</h5>
                  <p className="text-muted">
                    No notifications match your current filter.
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherNotifications;
